/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const numberToPercentageString = ({
    ratio,
    decimals = 2,
    showPercentage = true,
    showDashIfEmpty = true,
    showDashIfZero = false
}: {
    ratio: number;
    decimals?: number;
    showDashIfEmpty?: boolean;
    showPercentage?: boolean;
    showDashIfZero?: boolean;
}) => {
    if (typeof ratio !== 'number' || isNaN(ratio)) {
        return showDashIfEmpty ? '-' : undefined;
    }

    if (ratio === 0 && showDashIfZero) {
        return '-';
    }

    return `${(ratio * 100).toFixed(decimals)}${showPercentage ? '%' : ''}`;
};

export const truncateValue = (value: number, digits: number) => parseFloat(value.toFixed(digits));

export const numberToString = (n: number) => (n ? `${n}` : '-');
